import React from 'react'
import { Button, FormFieldSet, Modal } from '../../../../../components'

const ScheduleCallModal = ({isOpen,onClose}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={"Schedule Call"} width="max-w-2xl">
      <div className="grid grid-cols-2">
        <FormFieldSet type="datepicker" title="Select Date & Time" placeholder="select" showDropdown={false} showTime/>
      </div>
      <div className="flex justify-center my-5">
        <Button title={"Schedule"} size="sm"/>
      </div>
    </Modal>
  )
}

export default ScheduleCallModal